/**
 * @desc 配置用户角色
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.UserPermissionConfigureRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/role/permission/user`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
